import { Maybe } from 'src/graphql/schema';

type IContact = {
  id: string;
  name: string;
  email?: string;
  phone?: Maybe<string>;
  signatory?: boolean;
};

export const getEditedContactsSuggestedChangesItems = (editedContacts: IContact[], oldContacts: IContact[]) => {
  return editedContacts
    .map((contact) => {
      const oldContact = oldContacts.find(({ id }) => id === contact.id);
      const isEmailChanged = oldContact?.email !== contact.email;
      const isNameChanged = oldContact?.name !== contact.name;
      const isPhoneChanged = oldContact?.phone !== contact.phone;
      const changes = [
        {
          isChanged: isNameChanged,
          label: 'New name',
          value: contact.name,
        },
        {
          isChanged: isEmailChanged,
          label: 'New email',
          value: contact.email,
        },
        {
          isChanged: isPhoneChanged,
          label: 'New phone number',
          value: contact.phone || 'phone number removed',
        },
      ]
        .filter(({ isChanged }) => isChanged)
        .map(({ label, value }) => ({ label, value }));

      if (!changes.length) return undefined;

      return {
        label: 'Representative updated',
        value: oldContact?.name || '',
        children: changes,
      };
    })
    .filter((item) => Boolean(item)) as {
    label: string;
    value: string;
    children?: { label: string; value: string }[];
  }[];
};

export const getSignatorySuggestedChangesItems = (editedContacts: IContact[], oldContacts: IContact[]) => {
  return editedContacts
    .filter((contact) => {
      const oldContact = oldContacts.find(({ id }) => id === contact.id);
      const isSignatoryChanged = oldContact?.signatory !== contact.signatory;
      return isSignatoryChanged;
    })
    .map((contact) => {
      return {
        label: 'Signature updated',
        value: contact.name + ' ' + (contact.signatory ? 'added' : 'removed') + ' as a signatory',
      };
    });
};

export const getNewContactsSuggestedChangesItems = (newContacts: IContact[]) => {
  return newContacts.map((contact) => ({
    label: 'Representative added',
    value: contact.name,
  }));
};

export const getDeletedContactsSuggestedChangesItems = (deletedContacts: IContact[]) => {
  return deletedContacts.map((contact) => ({
    label: 'Representative removed',
    value: contact.name,
  }));
};
